import { lazy } from "react";

const PagesRoutes = [
  {
    path: "/admin/fees",
    component: lazy(() => import("../../view/oekfb/admin/subviews/fees")),
    layout: "VerticalLayout",
  },
  // PAGES
  {
    path: "/pages/blank-page",
    component: lazy(() => import("../../view/pages/blank")),
    layout: "VerticalLayout",
  },
  {
    path: "/pages/error-404",
    component: lazy(() => import("../../view/pages/errors/404")),
    layout: "FullLayout",
  },
  // ** CUSTOM PAGES __ OEKFB **
  // MARK: ADMIN PAGES
  {
    path: "/admin/",
    component: lazy(() => import("../../view/oekfb/admin")),
    layout: "HorizontalLayout",
    exact: true,
  },
  {
    path: "/admin/strafsenat/detail/:id",
    component: lazy(
      () =>
        import("../../view/oekfb/admin/subviews/strafsenat/StrafsenatDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/strafsenat",
    component: lazy(() => import("../../view/oekfb/admin/subviews/strafsenat")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/user",
    component: lazy(() => import("../../view/oekfb/admin/subviews/user")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/team/users",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/teams/teamUsers"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/team/pending",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/teams/pendingIndex"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/user_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/user/userDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/team",
    component: lazy(() => import("../../view/oekfb/admin/subviews/teams")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/team_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/teams/teamDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/match_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/matches/matchDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/players",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/teams/playerIndex"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/players_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/teams/playerDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/referee",
    component: lazy(() => import("../../view/oekfb/admin/subviews/referees")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/postpone",
    component: lazy(() => import("../../view/oekfb/admin/subviews/postpone")),
    layout: "VerticalLayout",
  },

  {
    path: "/admin/referee_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/referees/refereeDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/league",
    component: lazy(() => import("../../view/oekfb/admin/subviews/leagues")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/league_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/leagues/leagueDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/season_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/leagues/seasonDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/registrations",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/registrations"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/stadiums",
    component: lazy(() => import("../../view/oekfb/admin/subviews/stadium")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/stadium_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/stadium/stadiumDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/registration_detail/:id",
    component: lazy(
      () =>
        import("../../view/oekfb/admin/subviews/registrations/registrationsDetail"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/chat",
    component: lazy(() => import("../../view/oekfb/admin/subviews/chat/index")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/rechnung_erstellung",
    component: lazy(() => import("../../view//pages/invoice")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/rechnungen",
    component: lazy(() => import("../../view//pages/invoice/RechnungenIndex")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/transfers",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/transfers/TransferIndex"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/transfer_settings",
    component: lazy(
      () =>
        import("../../view/oekfb/admin/subviews/transfers/TransferSettings"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/news",
    component: lazy(() => import("../../view/oekfb/admin/subviews/news")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/push-notifications",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/pushNotifications"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/legal",
    component: lazy(() => import("../../view/oekfb/admin/subviews/legal")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/homepage-analytics",
    component: lazy(() => import("../../view/oekfb/admin/subviews/homepageAnalytics")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/email-templates",
    component: lazy(() => import("../../view/oekfb/admin/subviews/emailTemplates")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/homepage-content",
    component: lazy(() => import("../../view/oekfb/admin/subviews/homepageContent")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/sponsors",
    component: lazy(() => import("../../view/oekfb/admin/subviews/sponsors")),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/news_strafsenat",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/strafsenatNews"),
    ),
    layout: "VerticalLayout",
  },
  {
    path: "/admin/news_strafsenat_detail/:id",
    component: lazy(
      () =>
        import("../../view/oekfb/admin/subviews/strafsenatNews/StrafsenatNewsItemDetail"),
    ),
    layout: "VerticalLayout",
  },

  {
    path: "/admin/news_detail/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/news/newsItemDetail"),
    ),
    layout: "VerticalLayout",
  },

  {
    path: "/admin/people-events",
    component: lazy(() => import("../../view/oekfb/admin/subviews/events")),
    layout: "VerticalLayout",
    exact: true,
  },
  {
    path: "/admin/people-events/:id",
    component: lazy(
      () => import("../../view/oekfb/admin/subviews/events/eventDetail"),
    ),
    layout: "VerticalLayout",
  },
];

export default PagesRoutes;
